import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getFollowed } from '@api/followers';

export const getCoreFollowedSlice = createGetAsyncSlice({
	name: 'CoreFollowed',
	receive: true,
	request: true,
	requestHandler: getFollowed,
	retainDataOnRequest: true
});
